import React from 'react'
import { Link } from 'gatsby'
import styled, { css } from 'styled-components'
import { useScroll } from '../../hooks'
import { useMenuContext } from '../../state'

import Hamburger from 'hamburger-react'
import NavLinks from './NavLinks'
import Logo from '../Logo'
import { size } from '../../styles/Media'
import { spacing } from '../../styles/Rythms'
import { elevation } from '../../styles/Elevations'

const DesktopNav = styled.nav`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;

  background: transparent;
  transition: background-color 50ms;

  ${(props) =>
    props.isScrolled &&
    css`
      background: var(--background0);
      box-shadow: ${elevation[3]};
    `}

  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 64px;
  padding: 0 ${spacing[4]};
  z-index: 10;

  .logo {
    line-height: 0;
  }
  .logo svg {
    width: 131px;
  }

  @media screen and (max-width: ${size.laptop}) {
    justify-content: space-between;
    padding: 0 ${spacing[3]};

    .logo {
      left: calc(50% - 65px);
    }
  }

  .nav-links {
    @media screen and (max-width: ${size.laptop}) {
      display: none;
    }
  }

  .hamburger-react {
    display: none;
    z-index: 99;
    & > div > div {
      background: var(--text) !important;
    }
    @media screen and (max-width: ${size.laptop}) {
      display: block;
    }
  }
`

const DesktopNavbar = ({ category }) => {
  const { isMenuOpen, toggleMenu } = useMenuContext()
  const { isScrolled } = useScroll()

  return (
    <DesktopNav isScrolled={isScrolled}>
      <Link to="/" className="logo" onClick={() => isMenuOpen && toggleMenu}>
        <Logo />
      </Link>
      <NavLinks currentCategory={category} />
      <Hamburger
        rounded
        label="Afficher le menu"
        toggled={isMenuOpen}
        toggle={toggleMenu}
        duration={0.4}
      />
    </DesktopNav>
  )
}

export default DesktopNavbar
